import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home/Home';
import AdminLayout from './admin/AdminLayout';
import PianosAdmin from './admin/PianosAdmin';
import AdminLogin from './admin/AdminLogin'; // Adicione esta importação
import Layout from './components/Layouts';
import PianosList from './pages/PianosList';
import PianoPage from './pages/PianoPage'
import ScrollToTop from './components/Menu/components/ScrollToTop';
import CompraDePianos from './pages/CompraDePianos/CompraDePianos';
import DescupinizacaoPianos from "./pages/Descupinizacao/DescupinizacaoPianos";
import AluguelDePianos from './pages/AluguelDePianos/AluguelDePianos';
import Armazenagem from './pages/Armazenagem/armazenagem';
import ConsertoCravelhas from './pages/ConsertoCravelhas/ConsertoCravelhas';
import ServicoMarcenaria from './pages/ServicoMarcenaria/ServicoMarcenaria';
import ReformaMecanismo from './pages/ReformaMecanismo/ReformaMecanismo';
import ServicoRegulagem from './pages/ServicoRegulagem/ServicoRegulagem';
import RestauracaoMovel from './pages/RestauracaoMovel/RestauracaoMovel';
import RestauracaoTeclado from './pages/RestauracaoTeclado/RestauracaoTeclado';
import ServicoTransporte from './pages/ServicoTransporte/ServicoTransporte';
import Consignacao from './pages/Consignacao/Consignacao';
import ContatoOrcamento from './pages/Contato/ContatoOrcamento';
import Politicas from './pages/PoliticaDeVenda/politicaDeVenda';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        
              {/* Rotas públicas com Layout */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/pianos" element={<PianosList />} />
          <Route path="/pianos/:id" element={<PianoPage />} />
          <Route path="/compra" element={<CompraDePianos />} />
          <Route path="/descupinizacao" element={<DescupinizacaoPianos />} />
          <Route path="/aluguel" element={<AluguelDePianos  />} />
          <Route path="/armazenagem" element={<Armazenagem  />} />
          <Route path="/conserto-cravelhas" element={<ConsertoCravelhas />} />
          <Route path="/marcenaria" element={<ServicoMarcenaria />} />
          <Route path="/reforma-mecanismo" element={<ReformaMecanismo />} />
          <Route path="/regulagem" element={<ServicoRegulagem />} />
          <Route path="/restauracao-movel" element={<RestauracaoMovel  />} />
          <Route path="/restauracao-teclado" element={<RestauracaoTeclado  />} />
          <Route path="/transporte" element={<ServicoTransporte  />} />
          <Route path="/consignacao" element={<Consignacao  />} />
          <Route path="politica-de-vendas" element={<Politicas  />} />
          <Route path="/orcamento" element={<ContatoOrcamento  />} />
        </Route>
        

        {/* Rotas administrativas */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="pianos" replace />} />
          <Route path="pianos" element={<PianosAdmin />} />
          <Route path="login" element={<AdminLogin />} />
        </Route>

        {/* Redirecionamento para páginas não encontradas */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;

